import { render } from "./Sketch_guangdong.vue?vue&type=template&id=db3e017e&scoped=true&ts=true"
import script from "./Sketch_guangdong.vue?vue&type=script&lang=ts"
export * from "./Sketch_guangdong.vue?vue&type=script&lang=ts"

import "./Sketch_guangdong.vue?vue&type=style&index=0&id=db3e017e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db3e017e"]])

export default __exports__